import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useEffect } from 'react';
import { useSiteTimezoneContext } from 'src/contexts/SiteTimezoneContext/SiteTimezoneContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui/Stack';
import { AggregateMetricsTimePeriod } from 'src/WebApiController';

import { useDataInsights } from './DataInsightsContext';

interface ChartTooltipProps {
  label: string;
  payload: Record<string, any>[] | undefined;
  setValue: React.Dispatch<React.SetStateAction<number | null>>;
  renderValue: (item: Record<string, any>) => React.ReactNode;
}

const getDateFormat = ({
  timePeriod,
}: {
  timePeriod?: AggregateMetricsTimePeriod;
}) => {
  switch (timePeriod) {
    case AggregateMetricsTimePeriod.Today:
      return 'hh:mm a';
    case AggregateMetricsTimePeriod.LastWeek:
      return 'MMM dd, yyyy hh:mm a';
    case AggregateMetricsTimePeriod.LastMonth:
      return 'MMM dd, yyyy';
    case AggregateMetricsTimePeriod.LastYear:
      return 'MMM dd, yyyy';
    default:
      return 'MMM dd, yyyy';
  }
};

export const BasicTooltip = ({
  label,
  payload,
  setValue,
  renderValue,
}: ChartTooltipProps) => {
  const { timePeriod } = useDataInsights();
  const { timeZone } = useSiteTimezoneContext();

  useEffect(() => {
    if (payload && payload.length > 0) {
      const value = payload[0].value;
      setValue(value);
    }
  }, [payload, setValue]);

  return (
    <div
      style={{
        color: vars.color.textPrimary,
        fontSize: vars.typography.fontSize.xs,
        textAlign: 'center',
      }}
    >
      {payload?.map((item, index) => {
        const safeDateTime = item.payload.dateTime;
        return (
          <Stack key={index} direction="column" alignItems="center">
            <span>
              {format(
                toZonedTime(safeDateTime, timeZone),
                getDateFormat({ timePeriod })
              )}
            </span>
            <span>{renderValue(item)}</span>
          </Stack>
        );
      })}
    </div>
  );
};
